import { render } from "./VetoControlMoveModal.vue?vue&type=template&id=a81e5336"
import script from "./VetoControlMoveModal.vue?vue&type=script&lang=js"
export * from "./VetoControlMoveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__